import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { inventoryState } from "../types/index"
import { initialState } from "./initialState";

const getInventoryState = (state: RootState) => state.inventoryState || initialState


export const selectStatusFilter = createSelector(
    [getInventoryState],
    (inventoryState: inventoryState) => inventoryState.statusFilter 

)

export const selectMaterials = createSelector(
    [getInventoryState],
    (inventoryState: inventoryState) => inventoryState.materials 

)

export const selectIsLoading = createSelector(
    [getInventoryState],
    (inventoryState: inventoryState) => inventoryState.isLoading   

)

export const selectError = createSelector(
    [getInventoryState],
    (inventoryState) => inventoryState.error

)


export const selectFilteredWorkOrders = createSelector(
  [getInventoryState],
  (inventoryState: inventoryState) => {
    if (inventoryState.statusFilter === "ALL") {
      return inventoryState.materials;
    }

     return [];
    });
  
;